import {createContext} from 'preact';
import {StateUpdater, useMemo, useState} from 'preact/hooks';

import {PropsWithChildren} from 'utilities/props';
import {Nilable} from 'utilities/common/types';

import {ProductDetails} from './types';

interface ProductDetailsContextProps {
  productDetails: Nilable<ProductDetails>;
  variantId: Nilable<number>;
  sellingPlanId: Nilable<number>;
  setProductDetails: StateUpdater<Nilable<ProductDetails>>;
  setVariantId: StateUpdater<Nilable<number>>;
  setSellingPlanId: StateUpdater<Nilable<number>>;
}

export const ProductDetailsContextImpl =
  createContext<ProductDetailsContextProps>({
    productDetails: null,
    variantId: null,
    sellingPlanId: null,
    setProductDetails: () => {},
    setVariantId: () => {},
    setSellingPlanId: () => {},
  });

export function ProductDetailsContextProvider({children}: PropsWithChildren) {
  const [productDetails, setProductDetails] =
    useState<Nilable<ProductDetails>>(null);
  const [variantId, setVariantId] = useState<Nilable<number>>();
  const [sellingPlanId, setSellingPlanId] = useState<Nilable<number>>();

  const value = useMemo(
    () => ({
      productDetails,
      variantId,
      sellingPlanId,
      setProductDetails,
      setVariantId,
      setSellingPlanId,
    }),
    [productDetails, variantId, sellingPlanId],
  );

  return (
    <ProductDetailsContextImpl.Provider value={value}>
      {children}
    </ProductDetailsContextImpl.Provider>
  );
}
